import type { StoreActionApi } from 'react-sweet-state';

import { type RotationDetail } from '../../../common/types';
import {
	EditStep,
	type EditStore,
	type RecipientUpdate,
	type RotationDetailVariant,
} from '../state/types';
import { type ContainerProps } from '../types';

const setOrderRotationLoading =
	(loading: boolean) =>
	({ setState }: StoreActionApi<EditStore>) => {
		setState({
			orderRotationLoading: loading,
		});
	};

const goToDetail =
	({
		rotation,
		variant,
		recipientUpdate,
	}: {
		rotation: RotationDetail;
		variant: RotationDetailVariant;
		recipientUpdate?: RecipientUpdate;
	}) =>
	({ setState }: StoreActionApi<EditStore>) => {
		// TODO: should be removed (edit-rotation component should be responsible fully)
		// NOTE: due to timezone hack (useInitialValues) we apply, this triggers duplicate requests
		// setRotationAction(rotation);
		setState({
			step: EditStep.Detail,
			rotationDetailVariant: variant,
			initialRotation: rotation,
			recipientUpdate: recipientUpdate,
		});
	};

const goBack =
	() =>
	({ setState }: StoreActionApi<EditStore>, { setRotationAction }: ContainerProps) => {
		// TODO: should be removed (edit-rotation component should be responsible fully)
		setRotationAction(undefined);
		setState({
			step: EditStep.List,
			rotationDetailVariant: undefined,
			initialRotation: undefined,
			recipientUpdate: undefined,
		});
	};

export const actions = {
	setOrderRotationLoading,
	goToDetail,
	goBack,
};
